﻿﻿﻿﻿﻿﻿﻿﻿﻿﻿﻿﻿﻿<template>
  <div class="dashboard">
    <h2 class="page-title">营业仪表盘</h2>

    <!-- 今日 KPI -->
    <div class="section-title">今日数据</div>
    <el-row :gutter="16" class="kpi-row">
      <el-col :span="6">
        <div class="kpi-card kpi-blue">
          <div class="kpi-icon">💰</div>
          <div class="kpi-body">
            <div class="kpi-label">今日销售额（流水）</div>
            <div class="kpi-value">¥ {{ todayKpi.sales.toFixed(1) }}</div>
            <div class="kpi-extra">{{ todayKpi.orderCount }} 笔订单</div>
          </div>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="kpi-card kpi-cyan">
          <div class="kpi-icon">📥</div>
          <div class="kpi-body">
            <div class="kpi-label">今日进货额</div>
            <div class="kpi-value">¥ {{ todayKpi.purchase.toFixed(1) }}</div>
            <div class="kpi-extra">成本支出</div>
          </div>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="kpi-card kpi-green">
          <div class="kpi-icon">📈</div>
          <div class="kpi-body">
            <div class="kpi-label">今日利润</div>
            <div class="kpi-value">¥ {{ todayKpi.profit.toFixed(1) }}</div>
            <div class="kpi-extra">{{ todayKpi.profit >= 0 ? '盈利' : '亏损' }}</div>
          </div>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="kpi-card kpi-orange">
          <div class="kpi-icon">📊</div>
          <div class="kpi-body">
            <div class="kpi-label">今日毛利率</div>
            <div class="kpi-value">{{ todayKpi.margin.toFixed(1) }}%</div>
            <div class="kpi-extra">利润 / 销售额</div>
          </div>
        </div>
      </el-col>
    </el-row>

    <!-- 本月 KPI -->
    <div class="section-title">本月数据</div>
    <el-row :gutter="16" class="kpi-row">
      <el-col :span="6">
        <div class="kpi-card kpi-blue">
          <div class="kpi-icon">💰</div>
          <div class="kpi-body">
            <div class="kpi-label">本月销售额</div>
            <div class="kpi-value">¥ {{ monthKpi.sales.toFixed(1) }}</div>
            <div class="kpi-extra">{{ monthKpi.orderCount }} 笔订单</div>
          </div>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="kpi-card kpi-cyan">
          <div class="kpi-icon">📥</div>
          <div class="kpi-body">
            <div class="kpi-label">本月进货额</div>
            <div class="kpi-value">¥ {{ monthKpi.purchase.toFixed(1) }}</div>
            <div class="kpi-extra">成本支出</div>
          </div>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="kpi-card kpi-green">
          <div class="kpi-icon">📈</div>
          <div class="kpi-body">
            <div class="kpi-label">本月利润</div>
            <div class="kpi-value">¥ {{ monthKpi.profit.toFixed(1) }}</div>
            <div class="kpi-extra">{{ monthKpi.profit >= 0 ? '盈利' : '亏损' }}</div>
          </div>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="kpi-card kpi-orange">
          <div class="kpi-icon">📊</div>
          <div class="kpi-body">
            <div class="kpi-label">本月毛利率</div>
            <div class="kpi-value">{{ monthKpi.margin.toFixed(1) }}%</div>
            <div class="kpi-extra">利润 / 销售额</div>
          </div>
        </div>
      </el-col>
    </el-row>

    <!-- 日期筛选 + 趋势图 -->
    <el-card class="chart-card" shadow="hover">
      <template #header>
        <div class="chart-header">
          <span class="chart-title">营业趋势</span>
          <el-date-picker
            v-model="dateRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="YYYY-MM-DD"
            @change="onDateChange"
            style="width: 280px;"
          />
        </div>
      </template>
      <div ref="trendChart" class="chart"></div>
    </el-card>

    <!-- TOP 10 排行 -->
    <el-row :gutter="16" class="top-row">
      <el-col :span="12">
        <el-card class="top-card" shadow="hover">
          <template #header>
            <div class="top-title">
              <el-icon><Trophy /></el-icon>
              <span>热销商品 TOP 10</span>
              <el-radio-group v-model="topScope" size="small" class="top-toggle" @change="loadTop">
                <el-radio-button value="today">今日</el-radio-button>
                <el-radio-button value="all">全部</el-radio-button>
              </el-radio-group>
            </div>
          </template>
          <el-table :data="topSelling" stripe size="small" max-height="420">
            <el-table-column type="index" label="#" width="50" />
            <el-table-column prop="product_name" label="商品名称" min-width="160" />
            <el-table-column prop="quantity" label="销量" width="80" align="right" />
            <el-table-column label="销售额" width="100" align="right">
              <template #default="{ row }">¥ {{ Number(row.sales).toFixed(1) }}</template>
            </el-table-column>
          </el-table>
        </el-card>
      </el-col>
      <el-col :span="12">
        <el-card class="top-card" shadow="hover">
          <template #header>
            <div class="top-title">
              <el-icon><Money /></el-icon>
              <span>高利润商品 TOP 10</span>
              <el-radio-group v-model="topScope" size="small" class="top-toggle" @change="loadTop">
                <el-radio-button value="today">今日</el-radio-button>
                <el-radio-button value="all">全部</el-radio-button>
              </el-radio-group>
            </div>
          </template>
          <el-table :data="topProfit" stripe size="small" max-height="420">
            <el-table-column type="index" label="#" width="50" />
            <el-table-column prop="product_name" label="商品名称" min-width="160" />
            <el-table-column label="利润" width="100" align="right">
              <template #default="{ row }">¥ {{ Number(row.profit).toFixed(1) }}</template>
            </el-table-column>
            <el-table-column label="毛利率" width="90" align="right">
              <template #default="{ row }">
                <span class="pos">{{ Number(row.margin).toFixed(1) }}%</span>
              </template>
            </el-table-column>
          </el-table>
        </el-card>
      </el-col>
    </el-row>

    <!-- 经营分析区（交易统计 / 利润排行 / 今日亏损） -->
    <el-card class="analysis-card" shadow="hover">
      <template #header>
        <div class="analysis-title">
          <el-icon><DataAnalysis /></el-icon>
          <span>经营分析</span>
          <span class="analysis-sub">（独立日期选择）</span>
          <el-date-picker
            v-model="analysisDateRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="YYYY-MM-DD"
            @change="loadAnalysis"
            class="analysis-datepicker"
          />
        </div>
      </template>

      <el-tabs v-model="analysisTab" type="border-card">
        <!-- Tab 1: 交易统计 -->
        <el-tab-pane label="📦 交易统计" name="stats">
          <el-table :data="transactionStats" stripe size="small" max-height="400">
            <el-table-column type="index" label="#" width="50" />
            <el-table-column prop="product_name" label="商品名称" min-width="180" />
            <el-table-column label="买入总量" width="110" align="right">
              <template #default="{ row }">
                <span class="pos">{{ row.purchase_quantity || 0 }}</span>
              </template>
            </el-table-column>
            <el-table-column label="卖出总量" width="110" align="right">
              <template #default="{ row }">
                <span class="warn">{{ row.sale_quantity || 0 }}</span>
              </template>
            </el-table-column>
            <el-table-column label="净流转" width="110" align="right">
              <template #default="{ row }">
                <span :class="(row.sale_quantity - row.purchase_quantity) >= 0 ? 'pos' : 'neg'">
                  {{ (row.sale_quantity - row.purchase_quantity) }}
                </span>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>

        <!-- Tab 2: 利润排行 -->
        <el-tab-pane label="💰 利润排行" name="profit">
          <el-table :data="profitRanking" stripe size="small" max-height="400">
            <el-table-column type="index" label="#" width="50" />
            <el-table-column prop="product_name" label="商品名称" min-width="180" />
            <el-table-column label="销售额" width="120" align="right">
              <template #default="{ row }">¥ {{ safeNum(row.sales).toFixed(1) }}</template>
            </el-table-column>
            <el-table-column label="利润" width="120" align="right">
              <template #default="{ row }">
                <span class="pos">¥ {{ safeNum(row.profit).toFixed(1) }}</span>
              </template>
            </el-table-column>
            <el-table-column label="毛利率" width="100" align="right">
              <template #default="{ row }">
                <span class="pos">
                  {{ safeNum(row.sales) > 0 ? ((safeNum(row.profit) / row.sales) * 100).toFixed(1) : 0 }}%
                </span>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>

        <!-- Tab 3: 今日亏损预警（原"补货通知"重新定位） -->
        <el-tab-pane label="⚠️ 今日亏损" name="loss">
          <div v-if="todayLoss.length === 0" class="empty-tip">✅ 今日暂无亏损商品</div>
          <template v-else>
            <el-table :data="todayLoss" stripe size="small" max-height="400" show-summary :summary-method="lossSummary">
              <el-table-column type="index" label="#" width="50" />
              <el-table-column prop="product_name" label="商品名称" min-width="180" />
              <el-table-column label="盈亏" width="120" align="right">
                <template #default="{ row }">
                  <span class="neg">{{ safeNum(row.loss).toFixed(1) }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="stock" label="当前库存数量" width="120" align="right" />
              <el-table-column label="操作" width="120" align="center">
                <template #default="{ row }">
                  <el-button type="primary" size="small" @click="goToRestock(row.product_name)">去补货</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div class="loss-total-bar">
              <span class="loss-total-label">今日亏损累计：</span>
              <span class="loss-total-value">¥ {{ safeNum(todayLossTotal).toFixed(1) }}</span>
              <span class="loss-total-hint">（{{ todayLoss.length }} 笔亏损交易）</span>
            </div>
          </template>
        </el-tab-pane>
      </el-tabs>
    </el-card>
  </div>
</template>

<script>
import * as echarts from "echarts";
import axios from "axios";
import API_BASE from '@/api';
import { ref, reactive, onMounted, nextTick, watch } from "vue";
import { useRouter } from "vue-router";
// eslint-disable-next-line no-unused-vars
import { Trophy, Money, DataAnalysis } from '@element-plus/icons-vue';

export default {
  components: { Trophy, Money, DataAnalysis },
  setup() {
    const router = useRouter();
    const trendChart = ref(null);
    let trendChartInstance = null;

    // KPI 数据（默认值 0，避免模板报错）
    const todayKpi = reactive({ sales: 0, cost: 0, profit: 0, margin: 0, orderCount: 0, purchase: 0 });
    const monthKpi = reactive({ sales: 0, cost: 0, profit: 0, margin: 0, orderCount: 0, purchase: 0 });
    const topSelling = ref([]);
    const topProfit = ref([]);
    const topScope = ref('today');  // 今日 / 全部，影响 TOP 10 列表
    const dateRange = ref([]);  // [startDate, endDate]

    // 经营分析区
    const analysisTab = ref('stats');  // 默认显示交易统计
    const transactionStats = ref([]);
    const profitRanking = ref([]);
    const todayLoss = ref([]);
    const todayLossTotal = ref(0);  // 今日亏损累计（来自后端 total 字段）
    const analysisDateRange = ref([]);  // 经营分析区独立的日期选择，默认今天（在 onMounted 中设置）

    const safeNum = (v, d = 0) => (v == null || isNaN(Number(v)) ? d : Number(v));

    const loadKpi = async () => {
      try {
        const [t, m] = await Promise.all([
          axios.get(`${API_BASE}/api/dashboard/today`),
          axios.get(`${API_BASE}/api/dashboard/month`)
        ]);
        if (t.data.success && t.data.data) {
          Object.assign(todayKpi, {
            sales: safeNum(t.data.data.sales),
            cost: safeNum(t.data.data.cost),
            profit: safeNum(t.data.data.profit),
            margin: safeNum(t.data.data.margin),
            orderCount: safeNum(t.data.data.orderCount),
            purchase: safeNum(t.data.data.purchase)
          });
        }
        if (m.data.success && m.data.data) {
          Object.assign(monthKpi, {
            sales: safeNum(m.data.data.sales),
            cost: safeNum(m.data.data.cost),
            profit: safeNum(m.data.data.profit),
            margin: safeNum(m.data.data.margin),
            orderCount: safeNum(m.data.data.orderCount),
            purchase: safeNum(m.data.data.purchase)
          });
        }
      } catch (err) {
        console.error('加载 KPI 失败', err);
      }
    };

    const loadTop = async () => {
      try {
        // topScope: 'today' = 仅今日, 'all' = 全部
        // 后端 top-selling / top-profit 都接受 start/end 两个 query 参数
        const params = {};
        if (topScope.value === 'today') {
          const today = new Date().toISOString().slice(0, 10);
          params.start = today;
          params.end = today;
        }
        const [s, p] = await Promise.all([
          axios.get(`${API_BASE}/api/dashboard/top-selling`, { params }),
          axios.get(`${API_BASE}/api/dashboard/top-profit`, { params })
        ]);
        if (s.data.success) topSelling.value = s.data.data || [];
        if (p.data.success) topProfit.value = p.data.data || [];
      } catch (err) {
        console.error('加载 TOP 排行失败', err);
      }
    };

    const renderTrend = (data) => {
      if (!trendChart.value) return;
      // 后端返回的是 DESC（最新在前），折线图需要按时间正序展示
      // 同时把日期格式化为 MM-DD，只保留月份和日
      const sorted = [...data].sort((a, b) => new Date(a.date) - new Date(b.date));
      const dates = sorted.map(d => {
        const dt = new Date(d.date);
        return `${String(dt.getMonth() + 1).padStart(2, '0')}-${String(dt.getDate()).padStart(2, '0')}`;
      });
      trendChartInstance = echarts.init(trendChart.value);
      trendChartInstance.setOption({
        tooltip: {
          trigger: 'axis',
          valueFormatter: (val) => Number(val || 0).toFixed(1)
        },
        legend: { data: ['销售额', '进货额'], top: 0 },
        grid: { top: 40, left: 60, right: 30, bottom: 60 },
        xAxis: {
          type: 'category',
          data: dates,
          axisLine: { lineStyle: { color: '#999' } },
          axisLabel: {
            // 30 个点时强制隔一个显示一个，避免标签重叠
            interval: Math.max(0, Math.floor(dates.length / 12) - 1),
            rotate: 0
          }
        },
        yAxis: {
          type: 'value',
          name: '金额 (元)',
          splitNumber: 5,
          axisLabel: {
            formatter: (v) => v >= 10000 ? (v / 10000).toFixed(0) + '万' : v
          }
        },
        // dataZoom 保留 inside（鼠标滚轮缩放），默认显示全部数据
        dataZoom: [{ type: 'inside' }],
        series: [
          {
            name: '销售额', type: 'line', smooth: true, symbolSize: 6,
            data: sorted.map(d => safeNum(d.sales != null ? d.sales : d.revenue)),
            lineStyle: { color: '#32cd32' },
            areaStyle: { color: 'rgba(50, 205, 50, 0.2)' }
          },
          {
            name: '进货额', type: 'line', smooth: true, symbolSize: 6,
            data: sorted.map(d => safeNum(d.cost)),
            lineStyle: { color: '#ff6347' },
            areaStyle: { color: 'rgba(255, 99, 71, 0.2)' }
          }
        ]
      });
    };

    const loadTrend = async () => {
      try {
        const params = {};
        if (dateRange.value && dateRange.value.length === 2) {
          params.start = dateRange.value[0];
          params.end = dateRange.value[1];
        }
        const res = await axios.get(`${API_BASE}/api/daily-summary`, { params });
        if (res.data.success && Array.isArray(res.data.summary)) {
          await nextTick();
          renderTrend(res.data.summary);
        }
      } catch (err) {
        console.error('加载趋势失败', err);
      }
    };

    const onDateChange = () => {
      loadTrend();
      loadAnalysis();
    };

    // 加载经营分析（交易统计 / 利润排行 / 今日亏损）
    // 用独立的 analysisDateRange，不再跟随主折线图 dateRange
    const loadAnalysis = async () => {
      try {
        // 后端 stats.js / profit.js 接口参数约定不同
        //   product-transaction-stats: startDate, endDate
        //   profit-ranking:            start, end
        const params = {};
        const profitParams = {};
        if (analysisDateRange.value && analysisDateRange.value.length === 2) {
          params.startDate = analysisDateRange.value[0];
          params.endDate = analysisDateRange.value[1];
          profitParams.start = analysisDateRange.value[0];
          profitParams.end = analysisDateRange.value[1];
        }

        const [stats, profit, loss] = await Promise.all([
          axios.get(`${API_BASE}/api/product-transaction-stats`, { params }),
          axios.get(`${API_BASE}/api/profit-ranking`, { params: profitParams }),
          axios.get(`${API_BASE}/api/dashboard/today-loss`)
        ]);
        if (stats.data.success) transactionStats.value = stats.data.stats || [];
        if (profit.data.success) profitRanking.value = profit.data.data || [];
        if (loss.data.success) {
          todayLoss.value = loss.data.data || [];
          // 后端在 data.total 字段返回今日亏损累计
          todayLossTotal.value = safeNum(loss.data.total);
        }
      } catch (err) {
        console.error('加载经营分析失败', err);
      }
    };

    // 今日亏损表格底部汇总（el-table show-summary）
    const lossSummary = ({ columns, data }) => {
      const sum = data.reduce((acc, r) => acc + safeNum(r.loss), 0);
      return columns.map((col, idx) => {
        if (idx === 0) return '合计';
        if (col.label === '盈亏') return sum.toFixed(1);
        // 当前库存数量不合计
        return '';
      });
    };

    // 跳转到批量进货页（预填商品名称）
    const goToRestock = (productName) => {
      router.push({ path: '/BatchProduct-Entry', query: { product: productName } });
    };

    // 监听 TOP 10 切换（@change 事件在 el-radio-group 内偶尔不触发，加 watch 兜底）
    watch(topScope, () => { loadTop(); });

    onMounted(async () => {
      // 默认日期范围：最近 7 天（折线图）
      const today = new Date();
      const start = new Date();
      start.setDate(today.getDate() - 6);
      dateRange.value = [
        start.toISOString().slice(0, 10),
        today.toISOString().slice(0, 10)
      ];
      // 经营分析区独立日期：默认今天
      analysisDateRange.value = [today.toISOString().slice(0, 10), today.toISOString().slice(0, 10)];
      await Promise.all([loadKpi(), loadTop(), loadTrend(), loadAnalysis()]);
      window.addEventListener('resize', () => trendChartInstance && trendChartInstance.resize());
    });

    return {
      trendChart, todayKpi, monthKpi, topSelling, topProfit, topScope,
      dateRange, onDateChange, loadTop, safeNum,
      analysisTab, analysisDateRange, transactionStats, profitRanking,
      todayLoss, todayLossTotal, lossSummary, loadAnalysis,
      goToRestock
    };
  },
};
</script>

<style scoped>
.dashboard {
  padding: 0 4px;
}

.page-title {
  font-size: 20px;
  font-weight: 700;
  margin: 0 0 16px 0;
  color: var(--text-primary);
}

.section-title {
  font-size: 14px;
  font-weight: 600;
  color: var(--text-primary);
  margin: 20px 0 12px 0;
  display: flex;
  align-items: center;
  gap: 8px;
}

.section-title::before {
  content: '';
  width: 4px;
  height: 14px;
  background: var(--primary);
  border-radius: 2px;
}

.kpi-row {
  margin-bottom: 0;
}

/* ========== KPI 渐变卡片 ========== */
.kpi-card {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 20px 22px;
  border-radius: var(--radius-md);
  color: #fff;
  position: relative;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  transition: transform 0.2s, box-shadow 0.2s;
  min-height: 96px;
}

.kpi-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12);
}

.kpi-card::after {
  content: '';
  position: absolute;
  top: -30%;
  right: -20%;
  width: 140px;
  height: 140px;
  background: rgba(255, 255, 255, 0.12);
  border-radius: 50%;
  pointer-events: none;
}

.kpi-blue { background: var(--kpi-blue); }
.kpi-cyan { background: var(--kpi-cyan); }
.kpi-green { background: var(--kpi-green); }
.kpi-orange { background: var(--kpi-orange); }

.kpi-icon {
  font-size: 36px;
  width: 56px;
  height: 56px;
  background: rgba(255, 255, 255, 0.22);
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.kpi-body {
  flex: 1;
  min-width: 0;
}

.kpi-label {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.85);
  margin-bottom: 4px;
  font-weight: 500;
}

.kpi-value {
  font-size: 26px;
  font-weight: 700;
  color: #fff;
  line-height: 1.2;
  margin-bottom: 4px;
  letter-spacing: -0.5px;
}

.kpi-extra {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.8);
}

/* ========== 状态色 ========== */
.pos { color: var(--success); font-weight: 600; }
.neg { color: var(--danger); font-weight: 600; }
.warn { color: var(--warning); font-weight: 600; }

/* ========== 趋势图卡片 ========== */
.chart-card {
  margin-top: 20px;
  border-radius: var(--radius-md);
  border: 1px solid var(--border-lighter);
  box-shadow: var(--shadow-card);
}

.chart-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.chart-title {
  font-size: 16px;
  font-weight: 600;
  color: var(--text-primary);
  display: flex;
  align-items: center;
  gap: 6px;
}

.chart-title::before {
  content: '📈';
  font-size: 18px;
}

.chart {
  width: 100%;
  height: 360px;
}

/* ========== TOP 10 卡片 ========== */
.top-row {
  margin-top: 20px;
}

.top-card {
  border-radius: var(--radius-md);
  border: 1px solid var(--border-lighter);
  box-shadow: var(--shadow-card);
}

.top-title {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 15px;
  font-weight: 600;
  color: var(--text-primary);
}

.top-toggle {
  margin-left: auto;
}

/* ========== 经营分析 ========== */
.analysis-card {
  margin-top: 20px;
  border-radius: var(--radius-md);
  border: 1px solid var(--border-lighter);
  box-shadow: var(--shadow-card);
}

.analysis-title {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 16px;
  font-weight: 600;
  color: var(--text-primary);
}

.analysis-sub {
  font-size: 12px;
  color: var(--text-tertiary);
  font-weight: normal;
  margin-left: 4px;
}

.analysis-datepicker {
  margin-left: auto;
  width: 280px;
}

.empty-tip {
  text-align: center;
  padding: 50px 0;
  color: var(--success);
  font-size: 16px;
  background: var(--success-light);
  border-radius: var(--radius-sm);
}

/* ========== 今日亏损汇总 ========== */
.loss-total-bar {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 12px;
  padding: 12px 18px;
  background: linear-gradient(90deg, #fef0f0 0%, #fff5f5 100%);
  border: 1px solid #fbc4c4;
  border-radius: var(--radius-sm);
  font-size: 14px;
}

.loss-total-label {
  color: var(--text-secondary);
  font-weight: 600;
}

.loss-total-value {
  color: var(--danger);
  font-size: 20px;
  font-weight: 700;
}

.loss-total-hint {
  color: var(--text-tertiary);
  font-size: 12px;
  margin-left: auto;
}
</style>
